<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <b-row>
        <b-col>
          <b-row class="mb-3">
            <b-col cols="12">

            </b-col>
            <b-col cols="12">
              <DelegationForm
                :data="formData"
                :editing="isEditing"
                @update="updateForm"
                @updatecp="updateCodigoPostal"
                :errors="formErrors"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <BfButton
        v-if="!isEditing"
        @click="createDelegation"
        >
        Guardar
      </BfButton>

      <BfButton
        v-if="isEditing"
        variant="red"
        @click="showDeleteModal"
      >
        Eliminar
      </BfButton>

      <DeleteWarningModal
        v-model="displayDeleteModal"
        title="¿Desea eliminar esta empresa tasadora?"
        @confirm-deletion="deleteDelegation"
      />
    </template>
  </PageWrap>
</template>

<script>
import DelegationForm from '@/components/FormGroups/DelegationForm';
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import { delegationAPI, chargeAPI } from '@/api';

export default {
  name: 'DelegationsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: [chargeData],
      } = await delegationAPI.get(this.id);

      this.formData = chargeData;
    },
    async prepareForm() {
      const { data } = await delegationAPI.preCreate();

      this.formData = data;
    },
    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = {
          ...this.formData,
          ...newData,
        };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await delegationAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors, message }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message,
            type: 'error',
          });
        }
      }
    },
    async showDeleteModal() {
      this.displayDeleteModal = true;
    },
    async deleteDelegation() {
      try {
        const { message } = await delegationAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'delegations' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
    async createDelegation() {
      try {
        this.formErrors = {};
        const { data, message } = await delegationAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'delegation', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },
    async updateCodigoPostal({ value }) {
      const valueLength = value.length;
      if (valueLength >= 5) {
        try {
          const datosCp = await chargeAPI.autoCodigosPostales(value);
          this.formData.provincia = datosCp.provincia;
          this.formData.poblacion = datosCp.poblacion;
          this.formData.codigopostal = value;
        } catch ({ errors, message }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message,
            type: 'error',
          });
        }
      }
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Empresa Tasadora: ${this.formData.nombre || ''}` : 'Crear Empresa Tasadora';
    },
  },

  components: {
    DelegationForm,
    DeleteWarningModal,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
